import {HttpClient, HttpContext, HttpParams} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {TaskScope, TaskWithProgress} from '@gatewee/types/task';
import {PaginatedResponse} from '@gatewee/types/system';
import {Observable} from 'rxjs';
import {SKIP_SPINNER} from './tokens/spinner.token';

@Injectable({
  providedIn: 'root',
})
export class TaskService {
  private readonly http = inject(HttpClient);

  /** Fetch active (pending + processing) tasks for the given scope. */
  getActiveTasks(
    scope: TaskScope,
  ): Observable<PaginatedResponse<TaskWithProgress>> {
    return this.findAllPaginated(
      scope,
      0,
      20,
      {
        where: [
          {
            status: 'pending',
          },
          {
            status: 'processing',
          },
        ],
      },
      true,
    );
  }

  findAllPaginated(
    scope: TaskScope,
    skip: number,
    take: number,
    options?: Record<string, unknown>,
    skipSpinner = false,
  ): Observable<PaginatedResponse<TaskWithProgress>> {
    let params = new HttpParams()
      .set('skip', skip.toString())
      .set('take', take.toString())
      .set('fetchProgress', 'true');

    if (options && Object.keys(options).length > 0) {
      params = params.set('options', JSON.stringify(options));
    }

    return this.http.get<PaginatedResponse<TaskWithProgress>>(
      `/tasks/${scope}/paginated`,
      {
        params,
        context: new HttpContext().set(SKIP_SPINNER, skipSpinner),
      },
    );
  }

  findOne(
    scope: TaskScope,
    id: number,
    skipSpinner = false,
  ): Observable<TaskWithProgress> {
    return this.http.get<TaskWithProgress>(`/tasks/${scope}/${id}`, {
      context: new HttpContext().set(SKIP_SPINNER, skipSpinner),
    });
  }

  retry(scope: TaskScope, id: number): Observable<TaskWithProgress> {
    return this.http.post<TaskWithProgress>(`/tasks/${scope}/${id}/retry`, {});
  }
}
